module.exports = __webpack_public_path__ + "static/media/mirror-example-2.0acfa405.png";